
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { ServiceBase } from '@app/services/base.service';
import { LancamentoPesquisa } from '@app/pages/financeiro/lancamento/lancamento.model';
import { MovimentacaoFinanceira } from '@app/models/movimentacao-financeira.model';

@Injectable()
export class LancamentoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(movimentacao: MovimentacaoFinanceira): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'financeiro/lancamento/', movimentacao).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `financeiro/lancamento/${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `financeiro/lancamento/${id}`);
  }

  obterLancamentos(lancamentoPesquisa: LancamentoPesquisa): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `financeiro/lancamento/obterLancamentos`, lancamentoPesquisa, { headers: { meta: ['search'] }}).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

}
